import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  orgData: {},
  total: 0,
  selectedOrg: null,
  orgFeatures: [],
  orgFeaturesFetched: false,
  orgFlags: [],
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
